module.exports = __webpack_public_path__ + "img/ent-pay.464806ab.png";